import { render, staticRenderFns } from "./TransferLineOfficialAccountNewInfo.vue?vue&type=template&id=17be59e6&scoped=true&"
import script from "./TransferLineOfficialAccountNewInfo.vue?vue&type=script&lang=js&"
export * from "./TransferLineOfficialAccountNewInfo.vue?vue&type=script&lang=js&"
import style0 from "./TransferLineOfficialAccountNewInfo.vue?vue&type=style&index=0&id=17be59e6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17be59e6",
  null
  
)

export default component.exports